<template>
    <div class='bg'>
        <div class='leftTop'></div>
        <div class='rightTop'></div>
        <div class='leftBottom'></div>
        <div class='rightBottom'></div>
        <div class='leftCenter'></div>
        <div class='rightCenter'></div>
        <div class='drawContent'>
            <div class='title'>招天下抽取系统</div>
            <div class='czqy'>
                <!-- 标题 -->
                <div id='cqType' v-html='title'></div>
                <!-- 抽签流程 -->
                <div class='cqlc' v-show='!sfSet'>
                    <div class='icon_sixB lf'>
                        <div>1</div>
                        <p>抽签设置</p>
                    </div>
                    <div class='icon_next lf'></div>
                    <div class='icon_sixB lf'>
                        <div>2</div>
                        <p>抽取参数</p>
                    </div>
                    <div class='icon_next lf'></div>
                    <div class='icon_sixB lf'>
                        <div>3</div>
                        <p>抽签结果</p>
                    </div>
                </div>
                <!-- 抽签池 -->
                <div class='cqc' v-show='sfSet'>
                    <div class='cqItem' v-if="bxTjzbhxrData.length > 0">
                        <p v-if='currentCs==0'>从{{bxTjzbhxrData.length}}个编号中，抽取1个编号</p>
                    </div>
                    <div v-else class='cqItem'>
                        <p v-if='currentCs==0'>第一轮：从{{bh1.length}}个编号中，抽取1个编号</p>
                        <p v-else>第二轮：从{{bh2.length}}个编号中，抽取1个编号</p>
                    </div>
                    <div>
                        <!-- 当前抽奖结果 -->
                        <div class="batch flexbox" v-show="!running && (currentLucker||currentLucker===0)" v-cloak>
                            <div class="player" v-html='currentLucker'></div>
                        </div>
                        <!-- 动画 -->
                        <div id="myCanvasContainer">
                            <canvas width="500" height="500" id="myCanvas" ref="canvas">
                                <p>换个现代浏览器吧！</p>
                            </canvas>
                        </div>
                        <!-- 动态转圈数字 -->
                        <div id="tags" >
                            <ul>
                                <li v-for="(tag, index) in members" :key="index">
                                    <a onclick='return false' style="height: auto;font-size: 40px" v-html='tag'>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- 右侧所有结果展示 -->
                    <div class="result" v-show="results.length">
                        <div  class="lucky-dog" v-for="(item, index) in results" :key="index" v-cloak>
                            <p>第{{item.cs}}轮结果</p>
                            <div><span>{{item.jg}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='btns'>
                <button type="button" @click='isMask=true' :disabled='sfSet'>系统设置</button>
                <button v-if="!stopShow" type="button" @click='start()' :disabled='isNext||running||isOver||!sfSet'>开始抽签</button>
                <button v-else type="button" @click='stop()'>停止抽签</button>
                <button type="button" v-if="bxTjzbhxrData.length == 0" @click='next()' :disabled='!isNext||isOver||!sfSet'>下一轮</button>
                <button type="button" @click='cqOver()' :disabled='running||!sfSet||allDisabled'>抽签结束</button>
            </div>
        </div>
        <div class='mask' v-show="isMask"   v-cloak>
            <div class='pop' :class='isOver?"small":""'>
                <template v-if='!isOver'>
                    <div class="close" @click="isMask=false"></div>
                    <p class='cqTitle'>抽签规则设置</p>
                    <div class='setGz'>
                        <template v-if="bxTjzbhxrData.length > 0">
                                <p style="color:#FFF">1.第一轮：从以下编号中抽取  1个编号</p>
                                <div>请输入参与抽签的编号：
                                    <template>
                                        <el-input v-for='(item,index) in bxTjzbhxrData' readonly v-model='bxTjzbhxrValue[index].val' :key='"ipt1_"+index' maxlength="1"  oninput='value=value.replace(/[^0-9]/g,"")'></el-input>
                                    </template>
                                </div>
                        </template>
                        <template v-else>
                            <div v-for='i in 2' :key='i'>
                                <p>{{i}}、第{{i==1?"一":"二"}}轮：从以下编号中抽取1个{{i==1?"X":"Y"}}值</p>
                                <div>请输入参与抽签的编号：
                                <template v-if='i==1'>
                                        <el-input v-for='(a,index) in bh1' v-model='a.val' :key='"ipt1_"+index' maxlength="1"  oninput='value=value.replace(/[^0-9]/g,"")'></el-input>
                                        <span :class="['icon_add',bh1.length>=10?'icon_disable':'']" @click="bh1.length>=10?'':addIpt('bh1')"></span>
                                        <span :class="['icon_del',bh1.length==1?'icon_disable':'']" @click="bh1.length==1?'':delIpt('bh1')"></span>
                                    </template>
                                    <template v-else>
                                        <el-input v-for='(a,index) in bh2' v-model='a.val' :key='"ipt2_"+index' maxlength="1" oninput='value=value.replace(/[^0-9]/g,"")'></el-input>
                                        <span :class="['icon_add',bh2.length>=10?'icon_disable':'']" @click="bh2.length>=10?'':addIpt('bh2')"></span>
                                        <span :class="['icon_del',bh2.length==1?'icon_disable':'']" @click="bh2.length==1?'':delIpt('bh2')"></span>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class='btn-box'>
                        <button type="button" class='btn-true' @click='saveSet' :disabled='canSave'>确定</button>
                    </div>
                </template>
                <template v-else>
                    <div class="close" @click="refresh()" v-show='!time'></div>
                    <p class='cqTitle'>抽签结果</p>
                    <div class='cqjgContent'>
                        <p>本次抽签结束！</p>
                        <p v-for='(a,index) in results' :key='index'>
                            第{{a.cs}}轮结果：{{a.jg}}
                        </p>
                    </div>
                    <div class='btn-box'>
                        <button type="button" class='btn-true' @click='refresh()' v-show='!time'>确定</button>
                        <button type="button" class='btn-true' :disabled='time' v-show='time'>关闭倒计时：{{time}}</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"draw",
    computed:{
        canSave(){
            var flag1=this.bh1.find(a=>!a.val&&a.val!==0);
            var flag2=this.bh2.find(a=>!a.val&&a.val!==0);
            return flag1||flag2
        },
    },
    data(){
        return{
            bh1:localStorage.getItem('bh1')?JSON.parse(localStorage.getItem('bh1')):[{val:0},{val:1},{val:2},{val:3},{val:4}],
            bh2:localStorage.getItem('bh2')?JSON.parse(localStorage.getItem('bh2')):[{val:0},{val:1},{val:2},{val:3},{val:4},{val:5},{val:6},{val:7},{val:8},{val:9}],
            sfSet: localStorage.getItem('sfSet')?localStorage.getItem('sfSet'):false,//判断是否设置完成
            currentCs:localStorage.getItem('currentCs')?Number(localStorage.getItem('currentCs')):'0',//抽签次数
            running:false,//是否在抽签动画
            currentLucker: null,//当前轮中签者
            members: [],//滚球数
            isMask:false,//是否弹窗
            title:'抽签流程',
            isNext:false,//下一步按钮不可点
            results:localStorage.getItem('results')?JSON.parse(localStorage.getItem('results')):[],//总的中签结果数组
            isOver:localStorage.getItem('isOver')?true:false,//是否抽签完成
            allDisabled:false,//
            time:0,
            bxTjzbhxrData:[], // 从中标候选人进来后带的数据
            bxTjzbhxrValue:[], // 存储数据
            dData:'',
            stopShow:false, // 停止抽签按钮
        }
    },
    created(){
        this.bxTjzbhxrData = ['A', 'B', 'C', 'D']
        this.bxTjzbhxrValue = this.bxTjzbhxrData.map(el => {
            return { val: el }
        })
        let _this = this
        window.addEventListener('beforeunload', function(event) {
            localStorage.setItem('myParam', JSON.stringify({
                result: _this.results,
            }));
            // 清除参数
            localStorage.removeItem('myParam');
        });
    },
    methods: {
        addIpt(arr){
            var v=this[arr].length
            this[arr].push({val:v})
        },
        delIpt(arr){
            this[arr].pop();
        },
        // 保存设置
        saveSet(){
            localStorage.setItem('bh1',JSON.stringify(this.bh1))
            localStorage.setItem('bh2',JSON.stringify(this.bh2))
            localStorage.setItem('sfSet',true);
            this.sfSet=true;
            this.title='抽签池';
            this.isMask=false;
        },
        getSpeed: function () {
            return [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)];

        },
        getLuck(total,arr){
            var total=total;
            var index=Math.floor(Math.random() * total)
            return arr[index].val
        },
        // 停止抽签
        start: function () {
            var _this=this
            _this.running=true;
            TagCanvas.SetSpeed('myCanvas', [5, 1]);
            this.stopShow = true
            // setTimeout(function(){_this.stop()},2000);
        },
        //下一步
        next(){
            this.isNext=false;//下一步按钮不可点
            this.currentLucker=null;
            this.results=JSON.parse(localStorage.getItem("results"));
            this.currentCs=localStorage.getItem("currentCs");

        },
        // 抽签动画结束
        stop: function () {
            let _this = this;
            this.stopShow = false
            _this.running=false
            _this.isNext=true
            //保存抽签次数
            var currentCs= Number(localStorage.getItem('currentCs'));
            localStorage.setItem('currentCs',currentCs+1);
            //如果已经是最后 一次抽签了，那开始和下一步就不再可点
            if(currentCs<1){
                _this.isOver=false//还没结束
            }else{
                _this.isOver=true
                localStorage.setItem('isOver',true)
            }
            //生成随机数
            var obj={}
            console.log(_this.currentCs)
            if(_this.bxTjzbhxrValue.length > 0){
                // 判断是否为中标候选人
                if(_this.currentCs=='0'){
                    _this.currentLucker=_this.getLuck(_this.bxTjzbhxrValue.length,_this.bxTjzbhxrValue);
                    obj={
                        cs:'一',
                        jg:_this.currentLucker
                    }
                }
            }else{
                if(_this.currentCs=='0'){
                    console.log('===', _this.bh1.length);
                    _this.currentLucker=_this.getLuck(_this.bh1.length,_this.bh1);
                    obj={
                        cs:'一',
                        jg:_this.currentLucker
                    }
                }else if(_this.currentCs=='1'){
                    console.log('===', _this.bh2);
                    _this.currentLucker=_this.getLuck(_this.bh2.length,_this.bh2);
                    obj={
                        cs:'二',
                        jg:_this.currentLucker
                    }
                }
            }
            
            console.log(_this.currentLucker)
            var results=localStorage.getItem('results')?JSON.parse(localStorage.getItem("results")):[];
            results.push(obj)
            localStorage.setItem('results',JSON.stringify(results));
            TagCanvas.SetSpeed('myCanvas', _this.getSpeed());
            TagCanvas.Reload('myCanvas');
        },
        getRandomInt: function (min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        //抽签结束
        cqOver(){
            this.allDisabled=true
            this.isOver=true;//弹窗内容控制
            this.isMask=true;//弹窗出现
            this.currentLucker=null;//当前中签好像清空
            this.sfSet=false;
            this.results=JSON.parse(localStorage.getItem("results"))?JSON.parse(localStorage.getItem("results")):[];
            localStorage.removeItem('currentCs');
            localStorage.removeItem('results');
            localStorage.removeItem('isOver');
            localStorage.removeItem('bh1');
            localStorage.removeItem('bh2');
            localStorage.removeItem('sfSet',);
        },
        init: function () {
            try {
                TagCanvas.Start('myCanvas', 'tags', {
                    textColour: '#ffffff',
                    outlineColour:'transparent',
                    dragControl: 1,
                    decel: 0.95,
                    textHeight: 14,
                    minSpeed: 0.05,
                    txtOpt:true,
                    wheelZoom:false,//鼠标不可放大放小
                    initial: [
                        0.1 * Math.random() + 0.01,
                        -(0.1 * Math.random() + 0.01),
                    ],
                });
            } catch (e) {
                // something went wrong, hide the canvas container
                document.getElementById('myCanvasContainer').style.display =
                    'none';
            }
        },
        async refresh(){
            let params = {
                kbxmId: this.$route.query.kbxmId,
                lcId: this.$route.query.lcId,
                extractRule: `从4个编号中，抽取1个编号`,
                extractResult: this.results[0].jg,
            };
            const res = await this.$api.saveRecord(params);
            if (res.data.success) {
                let _this = this;
                _this.time = 3;
                let timeOut = setInterval(function () {
                    _this.time--;
                    if (_this.time == 0) {
                        _this.isMask = false;
                        // location.reload()
                        window.close();
                    }
                }, 1000);
            }
        }
    },
    mounted: function () {
        // 生成滚球数字
        for (var i = 1; i < 201; i++) {
            this.members.push(i)
        };
        this.$nextTick(function () {
            this.init();
        });
    },

}
</script>
<style lang="less" scoped>
.bg{
    position: absolute;
    top: 0;
    bottom:0;
    left:0;
    right:0;
    background:url('../../assets/images/draw/bg.png') no-repeat;
    background-size:cover;
    min-width: 1190px;
    min-height:880px;
}

.leftTop{
    position: absolute;
    top:20px;
    left:40px;
    background: url('../../assets/images/draw/left_1.png') no-repeat;
    width: 630px;
    height: 154px;
}
.leftCenter{
    position: absolute;
    top:174px;
    left:42px;
    bottom:496px;
    background: url('../../assets/images/draw/left_2.png') repeat;
    width: 14px;
}
.leftBottom{
    position: absolute;
    bottom:20px;
    left:20px;
    background: url('../../assets/images/draw/left_3.png') no-repeat;
    width: 419px;
    height:476px;
}
.rightTop{
    position: absolute;
    top:20px;
    right:40px;
    background: url('../../assets/images/draw/right_1.png') no-repeat;
    width: 630px;
    height: 154px;
}
.rightCenter{
    position: absolute;
    top:174px;
    right:42px;
    bottom:496px;
    background: url('../../assets/images/draw/right_2.png') repeat;
    width: 14px;
}
.rightBottom{
    position: absolute;
    bottom:20px;
    right:20px;
    background: url('../../assets/images/draw/right_3.png') no-repeat;
    width: 419px;
    height:476px;
}
#app {
    .drawContent{
        width: 100%;
        height:100%;
        padding:20px;
        .title{
            width:730px;
            height:70px;
            line-height: 60px;
            margin:5px auto 30px;
            text-align: center;
            color:#fff;
            font-size:36px;
            font-weight:bold;
            background:url('../../assets/images/draw/top_1.png') no-repeat;
        }
        .czqy{
            position: absolute;
            top:125px;
            left:150px;
            right:150px;
            bottom:165px;
            background:url('../../assets/images/draw/bg2.png') no-repeat;
            background-size: 100% 100%;
            padding:50px 40px;
        }
        .btns{
            position: absolute;
            bottom:70px;
            left: 0;
            width: 100%;
            text-align: center;
        }
        .btns button{
            width:250px;
            height:60px;
            border:1px solid #608add;
            border-radius: 10px;
            outline: none;
            color:#fff;
            font-size: 18px;
            font-weight: bold;
            margin:0 5px;
            cursor: pointer;
            background:linear-gradient(to bottom, #2a6ddc 0%,#1753b7 50%,#0745a8 54%,#2a6ddc 100%);
        }
        .btns button:disabled{
            color:#fff;
            border:1px solid transparent;
            cursor: not-allowed;
            background:linear-gradient(to bottom, #adacac 0%,#888888 50%,#848282 54%,#adacac 100%); 
            font-weight: 400;
        }
        #cqType{
            width:289px;
            height:50px;
            line-height:50px;
            margin:-52px auto 0;
            text-align: center;
            color:#fff;
            font-size: 24px;
            background:url('../../assets/images/draw/top_2.png') no-repeat;
            
        }
        .cqlc{
            width:950px;
            height:232px;
            position: absolute;
            top:50%;
            left:50%;
            margin-left:-475px;
            margin-top:-116px;
        }
        .icon_sixB{
            width:210px;
            height:232px;
            background: url('../../assets/images/draw/lbx.png') center no-repeat;
            color:#fff;
            text-align: center;
            font-size: 18px;
            font-weight:bold;
        }
        .icon_sixB div{
            width:38px;
            height:38px;
            line-height:34px;
            border-radius: 50%;
            border:2px solid #fff;
            margin:65px  auto 24px;
        }
        .icon_next{
            width:160px;
            height:232px;
            background:url('../../assets/images/draw/jt.png')  center no-repeat;
        }
        .lf{
            float:left;
        }
        .rt{
            float: right;
        }
    }
    .mask{
        position: absolute;
        top: 0;
        bottom:0;
        left:0;
        right:0;
        background:rgba(00,00,00,0.5);
        min-width: 1190px;
        min-height:880px;
    }
    .mask .pop{
        width:1200px;
        height:520px;
        position:absolute;
        top:50%;
        left:50%;
        margin-left:-600px;
        margin-top:-255px;
        background:rgba(19,46,92,0.9);
        z-index:9;
        padding:30px 60px 20px;
    }
    .mask .pop:before{
        content:'';
        display: block;
        position: absolute;
        top:-12px;
        bottom:0;
        left:0;
        right:0;
        width:1200px;
        height:532px;
        background:url('../../assets/images/draw/tck_1.png') no-repeat;
        background-size: 100%;
        z-index:-1;
    }
    .mask .pop.small{
        width:650px;
        height:362px;
        position:absolute;
        top:50%;
        left:50%;
        margin-left:-325px;
        margin-top:-180px;
        background:rgba(19,46,92,0.9);
        z-index:9;
        padding:30px 60px 40px;
    }
    .mask .pop.small:before{
        content:'';
        display: block;
        position: absolute;
        top:-9px;
        bottom:0;
        left:0;
        right:0;
        width:650px;
        /*height:384px;*/
        background:url('../../assets/images/draw/tck_2.png') no-repeat;
        background-size: 100%;
        z-index:-1;
    }
    .mask .pop .close{
        position: absolute;
        width:16px;
        height:16px;
        right:15px;
        top:15px;
        background:url("../../assets/images/draw/close.png") center no-repeat;
        cursor: pointer;
    }
    .cqTitle{
        color:#fff;
        font-size:25px;
        position: relative;
        top:-45px;
        text-align: center;
    }
    .setGz{
        margin-top:30px;
    }

    .setGz>div{
        background: rgba(16, 87, 166,0.1);
        line-height:35px;
        font-size: 16px;
        color:#fff;
        margin-bottom:15px;
        padding:30px 20px;
        p{
            margin-bottom:15px;
        }
        .el-input{
            width:66px;
            margin-right:5px;
            border-radius: 3px;
        }
        ::v-deep .el-input__inner{
            text-align: center;
            color: #1065C2;
            border:none;
            outline: none;
            font-size: 16px;
            background:rgba(255,255,255,0.9);
            border:1px solid #fff;
        }
    }
    .pop .btn-box{
        position: absolute;
        bottom:20px;
        left:0;
        width: 100%;
        text-align: center;
    }
    .btn-true{
        width:140px;
        height:42px;
        color:#fff;
        background: linear-gradient(0deg, #2A6DDC, #0745A8, #1753B7, #1F63D5);
        border: 1px solid #608ADD;
        border-radius: 5px;
    }
    .icon_add,.icon_del{
        width: 50px;
        height: 36px;
        border-radius: 3px;
        display: inline-block;
        background:#1065C2 url("../../assets/images/draw/add.png") center no-repeat;
        cursor: pointer;
        margin-right:5px;
        vertical-align: middle;
    }
    .icon_del{
        background:#1065C2 url("../../assets/images/draw/del.png") center no-repeat;
    }
    .icon_disable{
        cursor: not-allowed;
        &.icon_add{
            background:#999 url("../../assets/images/draw/add.png") center no-repeat;
        }
        &.icon_del{
            background:#999 url("../../assets/images/draw/del.png") center no-repeat;
        }
    }
    .cqItem p{
        font-size: 18px;
        font-weight:bold;
        color:#fff;
        height:44px;
        line-height:44px;
        padding:0 100px 0 10px;
        display: inline-block;
        background:linear-gradient(to right,rgba(99,132,255,0.3),rgba(255,255,255,0.05))
    }
    #myCanvasContainer{
        width: 500px;
        height: 500px;
        margin: 0 auto;
    }
    .batch {
        position: absolute;
        width: 80%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .player {
        display: inline-block;
        text-align: center;
        font-size: 60px;
        min-width: 120px;
        background: #fff;
        line-height: 80px;
        height:80px;
        color: #1d60ce;
        margin:5px;
        border-radius: 10px;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.8);
    }
    .result {
        position: absolute;
        right: 20px;
        top: 100px;
        color: #fff;
        width: 110px;
        font-size: 16px;
        text-align: right;
    }
    .lucky-dog{
        border:1px solid #144595;
        padding:12px;
        margin-bottom:10px;
        float:right;
        line-height:30px;
        background:rgba(20,69,149,0.17)
    }
    .lucky-dog p{
        margin-bottom:5px;
    }
    .lucky-dog span{
        margin:0 5px;
        font-size: 30px;
    }
    .lucky-dog>div{
        white-space:nowrap;
    }
    button:disabled{
        background:#999;
        color:#fff;
        cursor: not-allowed;
        font-weight: 400;
    }
    .cqjgContent p{
        color:#fff;
        font-size: 18px;
        margin-bottom:35px;
    }
    .cqjgContent p+p{
        margin-bottom:15px;
    }
    
}
[v-cloak]{
    display: none !important;
}
</style>